import { MoodleAccess } from 'src/common/moodleAccess';
import { JiraAccess } from './../../../common/jiraAccess';
import { environment } from 'src/environments/environment';
import { ToastService } from './../../services/toast.service';
import { managedLinkInfo, ExternalType } from 'src/common/managedLinkKey';
import { ManagedLinkKey } from '../../../common/managedLinkKey';
import { Directive, HostListener, Input, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { ManagedLink, ManagedComponentType } from 'src/common/managedLink';
import { Router } from '@angular/router';
import { tap, first } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[managedLink]'
})
export class ManagedLinkDirective implements OnDestroy {

	private readonly APP_SPECS: string = "toolbar=no,menubar=no,location=no";
	private readonly HC_NOMBRE: string = "hce";
	private readonly HC_WINDOW_NAME: string = "hc_main";
	private subscription: Subscription;

	@Input("managedLink")
	managedLinkKey: ManagedLinkKey;

	@Input("queryParams")
	queryParams;

	constructor(
		private managedLink: ManagedLink, private router: Router, private toastService: ToastService, private elementRef: ElementRef,
		private jiraAccess: JiraAccess, private moodleAccess: MoodleAccess
	) {
	}

	@HostListener( 'click' )
	onClick() {
		// Creo una thread independiente para lanzar la aplicación
		// Esto se debe que en el caso del SidebarComponent se hace el pedido de lanzar una aplicación y en el medio
		// del proceso de lanzamiento se cierra el SidebarComponent y con ello se liberaba de memoria el código de
		// esta directiva y no se ejecutaba el pipe del this.managedLink.resolveByString(...)
		setTimeout( () => {
			if( this.managedLinkKey == ManagedLinkKey.STORED_LINK || managedLinkInfo[ this.managedLinkKey ].isExternal ) {
				let ida: string =  this.queryParams? this.queryParams.ida: null;
				let idp: string = this.queryParams? this.queryParams.idp: null;
				let externalType: ExternalType = managedLinkInfo[ this.managedLinkKey ].externalType;

				this.subscription = this.managedLink.resolveByString( this.managedLinkKey, ida, idp, ManagedComponentType.EXTERNAL )
					.pipe(
						first(),
						tap( managedLinkResolved => {
							if( managedLinkResolved && managedLinkResolved.url ) {
								let url: string = managedLinkResolved.url;
								let windowName: string = null;
								if( this.managedLinkKey == ManagedLinkKey.STORED_LINK ) {
									windowName = this.getWindowName( ida );
									externalType = ExternalType.APP;
								} else {
									windowName = this.managedLinkKey;
									externalType = externalType? externalType: ExternalType.TAB;
								}

								if( this.jiraAccess.isJiraUrl( url ) )
									this.jiraAccess.openJira( url, windowName, this.elementRef );
								else if( this.moodleAccess.isMoodleUrl( url ) )
									this.moodleAccess.openMoodle( windowName, this.elementRef );
								else
									this.openWindow( url, windowName, externalType );
							} else
								this.toastService.danger( "No se ha podido resolver el link a la aplicación." );
						})
					).subscribe();
			} else {
				let prefixPath: string = managedLinkInfo[ this.managedLinkKey ].prefixPath;
				let path = ( prefixPath? prefixPath: '' ) + '/' + this.managedLinkKey;
				this.router.navigate( [ path ], { queryParams: this.queryParams } );
			}
		}, 0 );
	}

	ngOnDestroy(): void {
		// No sería necesario realizar un unsubscribe dado que el operador first() lo hace
		// pero realizo de todos modos un unsubscribe por si el usuario se va del componente antes
		// de que el observable resolveByString() emita un elemento, esto desde ya es muy poco
		// probable que suceda
		if( this.subscription )
			this.subscription.unsubscribe();
	}

/*
 * private methods
 */

	private openWindow( url: string, windowName: string, externalType: ExternalType ) {
		let windowSpecs: string = externalType == ExternalType.TAB? null:
			this.APP_SPECS + ",width=" + window.screen.width + ",height=" + window.screen.height;
		window.open( url, windowName, windowSpecs );
	}

	private getWindowName( ida: string ): string {
		return ida == this.HC_NOMBRE? this.HC_WINDOW_NAME: ida;
	}

}
